import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/HeroSection';
import FeaturedProducts from '../components/FeaturedProducts';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import PhilosophySection from '../components/PhilosophySection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <Box>
      <HeroSection />
      <FeaturedProducts />
      <AboutSection />
      <ServicesSection />
      <PhilosophySection />
      <TestimonialsSection />
      <ContactSection />
    </Box>
  );
};

export default HomePage;
